import { useEffect } from "react";
import { fetchLanguagesRequest } from "../../../redux/slices/languageSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBooksData,
  selectBooksStatus,
} from "../../../redux/selectors/bookSelectors";
import { fetchBooksRequest } from "../../../redux/slices/bookSlice";
import {
  selectLanguageIds,
  selectSyncChapters,
} from "../../../redux/selectors/filterSelectors";
import { addChapter } from "../../../redux/slices/filterSlice";
import { fetchHasPaidRequest } from "../../../redux/slices/hasPaidSlice";

export const useLanguageBooks = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchLanguagesRequest()); // ✅ Dispatch the action when component mounts
  }, [dispatch]);

  const syncChapters = useSelector(selectSyncChapters);
  const selectedLanguageIds = useSelector(selectLanguageIds);
  const bookStatus = useSelector(selectBooksStatus);
  const books = useSelector(selectBooksData);

  useEffect(() => {
    if (selectedLanguageIds && books.length === 0) {
      dispatch(fetchBooksRequest({ selectedLanguageIds })); // ✅ Dispatch the action when component mounts
    }
  }, [books, dispatch, selectedLanguageIds]);

  useEffect(() => {
    if (bookStatus === "success") {
      books.forEach((item) =>
        dispatch(
          addChapter({
            bookId: item.id, // The book ID you want to update
            syncChapters, // Whether to sync all chapters or not
          })
        )
      );
    }
  }, [bookStatus, books, dispatch, syncChapters]);

  useEffect(() => {
    dispatch(fetchHasPaidRequest()); // ✅ Dispatch the action when component mounts
  }, [dispatch]);
};
